exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs--1svoF .nav-tabs {\n  padding-left: 40px;\n  padding-right: 40px;\n  border-bottom: 2px solid #fff;\n  width: 100%;\n}\n\n.tabs--1svoF .nav-tabs .nav-link {\n  margin-bottom: -2px;\n  margin-top: 2px;\n  font-weight: bold;\n}\n\n.tabs--1svoF .nav-tabs .nav-link:hover {\n  color: #526f46;\n  border-bottom-color: #526f46;\n  background-color: #fff;\n}\n\n.dropdown--3Mxay {\n  background-color: transparent;\n  cursor: pointer;\n}\n\n.dropdown--3Mxay:focus {\n  outline: none;\n}\n\n", ""]);

// exports
exports.locals = {
	"tabs": "tabs--1svoF",
	"dropdown": "dropdown--3Mxay"
};